import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import standardTable from '@/components/standardTable/index';
import { intermediaryList, intermediaryTree, intermediaryList2, delIntermediary, intermediarystatus } from './request';
import agencyModel from './agencyModel';
export default {
  components: {
    standardTable,
    agencyModel
  },
  data() {
    return {
      agencyDialogVisible: false,
      nodeSelect: null,
      intermediaryList: [],
      tableHead: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80,
        align: 'center'
      }, {
        slots: {
          title: '中介机构'
        },
        dataIndex: 'name',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        scopedSlots: {
          customRender: 'status'
        },
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 150
      }],
      form: {
        intermediaryIdBig: undefined,
        intermediaryId: '',
        name: '',
        status: undefined
      },
      tableData: [],
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      loading: false
    };
  },
  watch: {
    filterText(val) {
      console.log(val);
      this.$refs.tree.filter(val);
    }
  },
  created() {
    intermediaryList({
      type: 1
    }).then(res => {
      console.log(res, 8999);
      if (res.length != 0) {
        this.intermediaryList = res;
        if (localStorage.getItem('homeIntermediaryId')) {
          let arr = res.filter(item => item.id == localStorage.getItem('homeIntermediaryId'));
          console.log(arr, 555);
          if (arr.length != 0) {
            this.form.intermediaryIdBig = arr[0].id;
            this.form.intermediaryId = arr[0].id;
            localStorage.setItem('homeIntermediaryId', arr[0].id);
          } else {
            this.form.intermediaryIdBig = res[0].id;
            this.form.intermediaryId = res[0].id;
            localStorage.setItem('homeIntermediaryId', res[0].id);
          }
        } else {
          this.form.intermediaryIdBig = res[0].id;
          this.form.intermediaryId = res[0].id;
          localStorage.setItem('homeIntermediaryId', res[0].id);
        }
        this.getIntermediaryTree();
        this.getIntermediaryTable();
      }
    });
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    searchFun() {
      this.pagination.page = 1;
      this.getIntermediaryTable();
    },
    addAgency() {
      this.agencyDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.agencyFrom.init({}, true, true);
      });
    },
    getStructure(type, id, type2) {
      intermediaryList({
        type: 1
      }).then(res => {
        if (res.length != 0) {
          this.intermediaryList = res;
          if (type2) {
            this.form.intermediaryIdBig = id;
            this.form.intermediaryId = id;
            localStorage.setItem('homeIntermediaryId', id);
          }
          this.getIntermediaryTree();
          this.getIntermediaryTable();
        }
      });
    },
    intermediaryFun(e) {
      this.form.intermediaryId = e;
      localStorage.setItem('homeIntermediaryId', this.form.intermediaryIdBig);
      this.getIntermediaryTable();
      this.getIntermediaryTree();
    },
    getIntermediaryTable() {
      let obj = this.form;
      Object.assign(obj, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      intermediaryList2(obj).then(res => {
        console.log(res.items, 'list');
        this.tableData = res.items || [];
        this.pagination.total = res.totalNum;
      });
    },
    getIntermediaryTree() {
      intermediaryTree({
        intermediaryId: this.form.intermediaryIdBig
      }).then(res => {
        this.data = res;
        this.$nextTick(() => {
          // 默认高亮选中节点
          this.$refs.tree.setCurrentKey(this.data[0].id);
        });
      });
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleStandardTableChange(val) {
      console.log(val);
      this.pagination = val;
      this.getIntermediaryTable();
    },
    handleNodeClick(data) {
      console.log(data);
      this.form.intermediaryId = data.id;
      this.getIntermediaryTable();
    },
    editDepartment(data) {
      console.log(data);
      this.agencyDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.agencyFrom.init(data, false, false);
      });
    },
    addAgency2(node, data) {
      console.log(data);
      this.agencyDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.agencyFrom.init({
          name: '',
          intermediaryId: data.id
        }, true, false);
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该机构') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delIntermediary({
          intermediaryId: val.intermediaryId
        }).then(res => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getIntermediaryTable();
          _this.getIntermediaryTree();
        });
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.intermediaryStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      intermediarystatus({
        intermediaryId: val.intermediaryId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功') + '!');
        val.status = val.status == 1 ? 0 : 1;
      });
    }
  }
};